export default __webpack_public_path__ + "static/media/Theinhardt-Regular.b574f1c1.otf";